<template>

    <main  v-if="auth.type === 'admin'">

        <div class="page-header" :class="{ 'active' : showPageHeader }">

            <div class="container-fluid">
                <div class="page-title">{{ pageTitle }}</div>
            </div>

        </div>

        <div class="page-body pt-0" v-if="fetcher.initialized">

            <div class="cover-image">
                
                <picture>
                  <source srcset="/images/company-portal/image-street.webp" type="image/webp">
                  <source srcset="/images/company-portal/image-street.jpg" type="image/jpg"> 
                  <img src="/images/company-portal/image-street.jpg">
                </picture>

            </div>

            <div class="container-fluid">
                <h1>{{ pageTitle }}</h1>
                <p style="max-width: 720px;">Här visas era kontaktupgifter. Har ni ändrat någon av uppgifterna eller har andra frågor till oss? Hör av er på <a href="mailto:support@halsoresurs.se">support@halsoresurs.se</a>.</p>

                <div class="row pt-10">

                    <div class="col-24 col-lg-12 col-xl-9 mb-8">

                            <div class="mb-8">
                                <h3>Adress</h3>
                                <span v-if="company.name">{{ company.name }}<br></span>
                                <span v-if="company.address_street_1">{{ company.address_street_1 }}<br></span>
                                <span v-if="company.address_street_2">{{ company.address_street_2 }}<br></span>
                                <span>{{ company.address_zip }} {{ company.address_city }}</span>
                            </div>

                            <div class="mb-lg-8">
                                <h3 v-if="company.organization_number">Organisationsnummer</h3>
                                <span v-if="company.organization_number">{{ company.organization_number }}<br></span>
                            </div>

                    </div>

                    <div class="col-24 col-lg-12 col-xl-9">

                        <div class="mb-8" v-if="company.invoice_email">
                            <h3>E-post för faktura</h3>
                            <span v-if="company.invoice_email">{{ company.invoice_email }}</span>
                        </div>

                        <div class="mb-lg-8">
                            <h3>Avtalskontakt</h3>
                            <span v-if="company.contract_name">{{ company.contract_name }}<br></span>
                            <span v-if="company.contract_email">{{ company.contract_email }}<br></span>
                            <span v-if="company.contract_phone_1">{{ company.contract_phone_1 }}<br></span>
                            <span v-if="company.contract_phone_2">{{ company.contract_phone_2 }}<br></span>
                        </div>


                    </div>

                </div>

            </div>

        </div>

    </main>

</template>

<script>
import scrollMixin from '../../../shared/mixins/scrollMixin'
import fetcher from '../../../shared/mixins/fetcher'
import patcher from '../../../shared/mixins/patcher'

export default {

    mixins: [
        scrollMixin,
        fetcher,
        patcher
    ],

    data () {
        return {
            pageTitle: 'Företagsuppgifter',
            showPageHeader: false,
            company: null,
            fetcher: {
                autoFill: [
                    'company'
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/data/company'
        },
    }
}
</script>
